// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"5dd67e12","166":"e2c778a7","182":"ee6fc4f8","241":"0b19d495","309":"9639f402","370":"038f002a","418":"b8784908","419":"80f9f6bb","982":"1906f67b","989":"8039c0e3"}[chunkId] + ".chunk.js";
};